import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { withRouter } from 'react-router';
import { MuiThemeProvider, withStyles } from 'material-ui/styles';
import { AppProgressIndicator } from 'components/AppProgress';
import './styles/styles.less';
import Routes from './pages';

const styles = theme => ({
  '@global': {
    body: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      fontWeight: theme.typography.fontWeightLight,
      backgroundColor: '#fff'
    }
  }
});

@withRouter
class ScrollToTop extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    children: PropTypes.any
  };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

const App = withStyles(styles)(() => (
  <div>
    <AppProgressIndicator />
    <Routes />
  </div>
));

const AppWrapper = ({ store, theme, history }) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ScrollToTop>
        <MuiThemeProvider theme={theme}>
          <App />
        </MuiThemeProvider>
      </ScrollToTop>
    </ConnectedRouter>
  </Provider>
);

AppWrapper.propTypes = {
  store: PropTypes.any.isRequired,
  theme: PropTypes.any.isRequired,
  history: PropTypes.any.isRequired,
};

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/App.js